// All or portions of this file Copyright © 2019 Amazon Web Services, Inc. or its affiliates or licensors.
// All rights reserved. For full license terms and conditions, please see the LICENSE file at the root of
// this distribution (the "License") or go to https://content.sumerian.amazonaws.com/engine/latest/license.txt.
// All use of the software is governed by the License. All materials are made available on an "AS IS" BASIS, WITHOUT
// WARRANTIES OR CONDITIONS OF ANY KIND, express or implied. Do not remove or modify any license notices.
import Source from '../../animationpack/blendtree/Source';

/**
 * A blend tree node that does not update any clips or sources below it in the blend tree. This is useful for freezing an animation, often
 *        for purposes of transitioning between two unrelated animations.
 */
class FrozenClipSource extends Source {
  /**
   * @param {(ClipSource|BinaryLerpSource|FrozenClipSource|ManagedTransformSource)} source Our sub source.
   * @param {number} frozenTime The time we are frozen at.
   */
  constructor(source, frozenTime) {
    super();
    this._source = source;
    this._time = frozenTime;
  }

  /**
   * @returns a source data mapping for the channels in this clip source
   */
  getSourceData() {
    return this._source.getSourceData();
  }

  /**
   * Sets start time of clipinstance to 0, so frozenTime will calculate correctly
   */
  resetClips() {
    this._source.resetClips(0);
  }

  /**
   * This will be called by a {@link SteadyState}, but will not update the animation, and will return true, to indicate animation is still active
   */
  setTime() {
    this._source.setTime(this._time);
    return true;
  }

  /**
   * @returns {FrozenClipSource}
   */
  clone() {
    const cloned = new FrozenClipSource(
      this._source.clone(),
      this._time,
    );

    return cloned;
  }
}

export default FrozenClipSource;
